import { render, staticRenderFns } from "./DeviceWidget.vue?vue&type=template&id=76bec46c&scoped=true"
import script from "./DeviceWidget.vue?vue&type=script&lang=js"
export * from "./DeviceWidget.vue?vue&type=script&lang=js"
import style0 from "./DeviceWidget.vue?vue&type=style&index=0&id=76bec46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bec46c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
